import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

/**
 * Textos del paginador en español para los modales de errores de integración.
 * La línea estándar usa el CustomMatPaginatorIntl compartido (basado en
 * Transloco); esta rama no tiene Transloco, por eso la clase local.
 */
@Injectable()
export class SpanishPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Registros por página:';
  override nextPageLabel = 'Página siguiente';
  override previousPageLabel = 'Página anterior';
  override firstPageLabel = 'Primera página';
  override lastPageLabel = 'Última página';

  override getRangeLabel = (pageIndex: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    const start = pageIndex * pageSize + 1;
    const end = Math.min((pageIndex + 1) * pageSize, length);
    return `${start} – ${end} de ${length}`;
  };
}
